import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FaCapsules, FaClock, FaInfoCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { CCard } from "@coreui/react";
import ClipLoader from "react-spinners/ClipLoader";
import "./MedicineCard.css";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import HealthStatusIndicator from "../../../../../../../components/HealthStatusIndicator/HealthStatusIndicator";
import { HEALTH_METRIC_TAGS, getHealthStatusByTag } from "../../../../../../config/thresholds";

const MedicineCard = ({
  medicineName,
  frequency,
  intake,
  medicineUnit,
  loading,
  tooltipInfo,
  intervalUnit,
  drugRegularityId,
  intervalNumber,
  startDate,
  endDate,
  adherencePercentage,
  patientData = null // NEW: Patient data for gender-specific calculations
}) => {
  const { t } = useTranslation();

  const [startDay, setStartDay] = useState(undefined)
  const [startMonth, setStartMonth] = useState(undefined)
  const [startYear, setStartYear] = useState(undefined)


  const [endDay, setEndDay] = useState(undefined)
  const [endMonth, setEndMonth] = useState(undefined)
  const [endYear, setEndYear] = useState(undefined)

  // Calculate adherence health status
  const getAdherenceHealthStatus = () => {
    if (adherencePercentage === null || adherencePercentage === undefined) {
      return 'neutral';
    }

    const gender = patientData?.sex?.toLowerCase() === 'f' ? 'female' : 'male';
    return getHealthStatusByTag(adherencePercentage, HEALTH_METRIC_TAGS.THERAPY_ADHERENCE, gender);
  };

  const adherenceStatus = getAdherenceHealthStatus();

  const textDays = () => {
    // console.log("drugRegularityId", drugRegularityId)
    if(drugRegularityId === 1){
      return t("Giornaliero")
    } else if(drugRegularityId === 2){
      if(intervalNumber<=2)
        return t(`${intervalNumber}_volte`) + ' ' + t(intervalUnit)
      else
        return `${intervalNumber}` + ' ' + t('volte') + ' ' + t(intervalUnit)
    } else if(drugRegularityId === 3){
      let arrayDays = frequency.split(', ')
      arrayDays = arrayDays.map(day => t(day))
      return arrayDays.join(', ')
    }
  }

  const convertTo12h = (time) => {
    const [hour, minutes] = time.split(':')

    const hour12 = parseInt(hour)%12 === 0 ? 12 : parseInt(hour)%12

    if(hour>=12)
      return `${hour12 <= 9 ? '0'+hour12 : hour12}:${minutes} PM`
    else
      return `${hour12 <= 9 ? '0'+hour12 : hour12}:${minutes} AM`
  }

  useEffect(() => {
    
    if(startDate && endDate){
      let start_date = new Date(startDate.split('T')[0])
      let end_date = new Date(endDate.split('T')[0])

      
      // start_date.setDate(start_date.getDate() + 1); // Add one day
      // end_date.setDate(end_date.getDate() + 1); // Add one day
      

      setStartDay(start_date.getDate() <= 9 ? '0'+start_date.getDate() : String(start_date.getDate()))
      setEndDay(end_date.getDate() <= 9 ? '0'+end_date.getDate() : String(end_date.getDate()))

      setStartMonth(start_date.getMonth() <=8 ? '0'+String(start_date.getMonth()+1) : String(start_date.getMonth()+1))
      setEndMonth(end_date.getMonth() <=8 ? '0'+String(end_date.getMonth()+1) : String(end_date.getMonth()+1))

      setStartYear(String(start_date.getFullYear()))
      setEndYear(String(end_date.getFullYear()))
  }

  }, [])
  return (
    <CCard className={`background-card-therapies ${adherenceStatus !== 'neutral' ? `medicine-card--${adherenceStatus}` : ''}`}>
      {!loading && (
        <>
          <div className="div-row">
            <Tooltip
              title={<span className="tooltip-window" dangerouslySetInnerHTML={{__html: tooltipInfo}}></span>}
              arrow
            >
              <IconButton>
                <FaInfoCircle className="info-icon-med" />
              </IconButton>
            </Tooltip>
          </div>

          {/* Health Status Indicator for Therapy Adherence */}
          {adherenceStatus !== 'neutral' && adherencePercentage !== null && (
            <HealthStatusIndicator 
              status={adherenceStatus}
              size="medium"
              position="top-left"
              showBorder={true}
            />
          )}

          <h3>{t("therapies")}</h3>

          {intake.length > 0 && <div className="slide-header">
            {medicineName !== "" && (
              <div className="header">
                <h6>{medicineName}</h6>
                <h6 style={{
                  color: "white",
                  margin: "0px",
                  marginBottom: "0px",
                }}>{textDays().toUpperCase()}</h6>

              </div>
            )}
          </div>}

          {/* Therapy Adherence Display */}
          {adherencePercentage !== null && adherencePercentage !== undefined && (
            <div className="adherence-display">
              <h6 className="adherence-label">{t("adherencePercentage")}:</h6>
              <h6 className={`adherence-value health-status-${adherenceStatus}`}>{adherencePercentage.toFixed(1)}%</h6>
              {/* <span className={`adherence-value health-status-${adherenceStatus}`}>
                {adherencePercentage.toFixed(1)}%
              </span> */}
            </div>
          )}

        { startDate && endDate && intake.length > 0 &&
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
        }}>
            <div style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <h6 style={{
                color: "white",
              }}>{t('startDate')}</h6>
              <h6 style={{
                color: "white",
              }}>
                {/* { t('volte') === 'volte' ? `${startDay}-${startMonth}-${startYear}` :  `${startMonth}-${startDay}-${startYear}`} */}
                {`${startDay}-${startMonth}-${startYear}`}
              </h6>
            </div>

            <div style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <h6 style={{
                color: "white",
              }}>{t('endDate')}</h6>
              { 
                endYear !== '9999' &&
              <h6 style={{
                color: "white",
              }}>
                {/* { t('volte') === 'volte' ? `${endDay}-${endMonth}-${endYear}` :  `${endMonth}-${endDay}-${endYear}`} */}
                {`${endDay}-${endMonth}-${endYear}`}
              </h6>}
              {
                endYear === '9999' &&
                <h6 style={{
                  color: "white",
                }}>----</h6>
              }
            </div>

          </div>}

          {intake.length !== 0 && (
            <div className="intake">
              <div className="intake-inner">
                {intake.map((item, index) => (
                  <div key={index} className="intake-item-therapies">
                    <div className="item">
                      <FaCapsules className="icon" />
                      <span>
                        {item.quantity} {t(medicineUnit)}
                      </span>
                    </div>
                    <div className="item">
                      <FaClock className="icon" />
                      <span>{ t('volte') === 'volte' ? item.time : convertTo12h(item.time)}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {intake.length === 0 && (
            <div className="med-div">
              <h6>{t("noActiveTherapies")}</h6>
            </div>
          )}
        </>
      )}
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <ClipLoader
            color="white"
            loading={loading}
            size={50}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}
    </CCard>
  );
};

MedicineCard.propTypes = {
  medicineName: PropTypes.string.isRequired,
  medicineUnit: PropTypes.string.isRequired,
  frequency: PropTypes.string.isRequired,
  intake: PropTypes.arrayOf(
    PropTypes.shape({
      quantity: PropTypes.string.isRequired,
      time: PropTypes.string.isRequired,
    }),
  ).isRequired,
  loading: PropTypes.bool.isRequired,
  tooltipInfo: PropTypes.string.isRequired,
  intervalUnit: PropTypes.string,
  drugRegularityId: PropTypes.number,
  intervalNumber: PropTypes.number,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  adherencePercentage: PropTypes.number, // NEW: Individual therapy adherence
  patientData: PropTypes.object, // NEW: Patient data for gender-specific calculations

};

export default MedicineCard;
